import { AxiosInstance } from 'axios'
import { BaseApi } from '@/api/BaseApi'
import { IPrefApiResponse } from '@/types/common/pref'

export const PATH = {
  GET_PREF: '/api/common/pref',
} as const

export class PrefApi {
  baseApi: BaseApi
  constructor(axios: AxiosInstance) {
    this.baseApi = new BaseApi(axios)
  }

  /**
   * 都道府県情報取得
   */
  public async getPref(): Promise<IPrefApiResponse> {
    const { data } = await this.baseApi.get<IPrefApiResponse>(PATH.GET_PREF)
    return data
  }
}
